var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0"},attrs:{"fluid":"","grid-list-xs":""}},[_c('MonitorList',{attrs:{"system":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }